import React, { useState } from 'react';
import get from 'lodash/get';
import { Button, Card, Form, Input, Spin, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import { unwrapResult } from '@reduxjs/toolkit';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { login } from '../../redux/auth/authSlice';
import { DASHBOARD, FORGOT_PASSWORD } from '../../constants/routes';
import { LOGO_URL, BRAND_NAME } from '../../constants/brand';
import { useDocumentTitle } from '../../components/PageHeader';

const LoginScreen = () => {
    const [loading, setLoading] = useState(false);
    const isLoggedIn = useSelector((state) => get(state, 'auth.isLoggedIn'));
    const { state: locationState } = useLocation();

    const dispatch = useDispatch();
    useDocumentTitle('Login');

    if(isLoggedIn){
        // Back to the page the auth guard interrupted, or the dashboard
        return <Navigate to={get(locationState, 'from') || DASHBOARD} replace={true} />
    }

    const onFinish = (values) => {
        setLoading(true);
        dispatch(login(values))
            .then((result) => {
                setLoading(false);
                if(login.fulfilled.match(result)){
                    message.success("Logged in Successfully !!");
                }
            })
            .catch(() =>{
                setLoading(false);
            })
    };

    return (
        <div className='login-page'>
            <Spin spinning={loading}>
                <Card bordered={false} className='login-card'>
                    <div className='login-container'>
                        <div className='login-brand'>
                            <img src={LOGO_URL} alt='GoGo Power' draggable={false} />
                            <span className='login-brand-text'>{BRAND_NAME}</span>
                        </div>

                        <div className='heading'>Login to Dashboard</div>

                        <div className='login-form mt-30'>
                            <Form
                                name='basic'
                                layout='vertical'
                                initialValues={{}}
                                onFinish={onFinish}
                                onFinishFailed={()=>{}}
                                autoComplete='off'
                                requiredMark={false}
                            >
                                <div>
                                    <Form.Item
                                        label="Email"
                                        name="email_address"
                                        className="form-item"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please enter your registered email",
                                            },
                                            {
                                                type: 'email',
                                                message: 'Please input a valid email'
                                            }
                                        ]}
                                    >
                                        <Input size='large' placeholder='Email' />
                                    </Form.Item>
                                </div>

                                <div>
                                    <Form.Item
                                        label="Password"
                                        name="password"
                                        className="form-item"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter your password !'
                                            },
                                        ]}
                                    >
                                        <Input.Password size='large' placeholder='Password' />
                                    </Form.Item>
                                    <div className='login-forgot-link'>
                                        <Link to={FORGOT_PASSWORD}>Forgot password?</Link>
                                    </div>
                                </div>

                                <div className="mt-20">
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            block
                                            size='large'
                                            htmlType="submit"
                                            className='default-primary-btn'
                                        >
                                            Log in
                                        </Button>
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Card>
            </Spin>
        </div>
    );
};

export default LoginScreen;
